export const DEFAULT_LANDSCAPE_HEIGHT = 100;
export const DEFAULT_PORTRAIT_HEIGHT = 300;
